interface SectionHeadingProps {
  kicker: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  subtitle,
  dark = false,
  align = "left",
}: SectionHeadingProps) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start";
  return (
    <div className={`flex flex-col gap-3 ${alignCls} max-w-3xl`}>
      <div className="flex items-center gap-3">
        <span className="inline-flex h-px w-8 bg-primary-500" aria-hidden="true" />
        <span
          className={`kicker text-[11px] font-bold uppercase ${dark ? "text-accent-300" : "text-primary-600"}`}
        >
          {kicker}
        </span>
      </div>
      <h2
        className={`font-heading text-2xl font-bold leading-snug md:text-[34px] ${
          dark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle ? (
        <p
          className={`text-sm leading-relaxed md:text-[15px] ${
            dark ? "text-background-200/80" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}